'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBlurOn = function MdBlurOn(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.4 14.1c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5z m0 6.8c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5z m-6.8 7.5c1 0 1.8 0.7 1.8 1.6s-0.8 1.6-1.8 1.6-1.6-0.7-1.6-1.6 0.7-1.6 1.6-1.6z m0-14.3c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5z m6.8 20c0.4 0 0.7 0.4 0.7 0.9s-0.3 0.9-0.7 0.9-0.9-0.4-0.9-0.9 0.4-0.9 0.9-0.9z m0-5.7c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.6-1.6 1.6-1.8-0.7-1.8-1.6 0.8-1.6 1.8-1.6z m11.6-5.9c0.5 0 0.9 0.4 0.9 0.9s-0.4 0.7-0.9 0.7-0.9-0.3-0.9-0.7 0.4-0.9 0.9-0.9z m-5-14.1c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.6-1.6 1.6-1.6-0.7-1.6-1.6 0.7-1.6 1.6-1.6z m0 6.6c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.8-1.6 1.8-1.6-0.8-1.6-1.8 0.7-1.6 1.6-1.6z m0 13.4c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.6-1.6 1.6-1.6-0.7-1.6-1.6 0.7-1.6 1.6-1.6z m0-6.8c0.9 0 1.6 0.8 1.6 1.8s-0.7 1.6-1.6 1.6-1.6-0.7-1.6-1.6 0.7-1.8 1.6-1.8z m-13.4-0.7c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5z m0-9.3c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.6 1.6-1.6 1.8 0.7 1.8 1.6-0.8 1.6-1.8 1.6z m0-5.7c-0.4 0-0.7-0.4-0.7-0.9s0.3-0.9 0.7-0.9 0.9 0.4 0.9 0.9-0.4 0.9-0.9 0.9z m0 28.2c0.5 0 0.9 0.4 0.9 0.9s-0.4 0.9-0.9 0.9-0.7-0.4-0.7-0.9 0.3-0.9 0.7-0.9z m-11.6-11.6c0.5 0 0.9 0.4 0.9 0.9s-0.4 0.7-0.9 0.7-0.9-0.3-0.9-0.7 0.4-0.9 0.9-0.9z m18.4-16.6c-0.5 0-0.9-0.4-0.9-0.9s0.4-0.9 0.9-0.9 0.7 0.4 0.7 0.9-0.3 0.9-0.7 0.9z m0 5.7c-1 0-1.8-0.7-1.8-1.6s0.8-1.6 1.8-1.6 1.6 0.7 1.6 1.6-0.7 1.6-1.6 1.6z m11.6 5.9c-0.5 0-0.9-0.4-0.9-0.9s0.4-0.7 0.9-0.7 0.9 0.3 0.9 0.7-0.4 0.9-0.9 0.9z m-25-9.1c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.6-1.6 1.6-1.6-0.7-1.6-1.6 0.7-1.6 1.6-1.6z m-5 7.5c0.5 0 0.9 0.3 0.9 0.7s-0.4 0.9-0.9 0.9-0.9-0.4-0.9-0.9 0.4-0.7 0.9-0.7z m5-0.9c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.8-1.6 1.8-1.6-0.8-1.6-1.8 0.7-1.6 1.6-1.6z m0 13.4c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.6-1.6 1.6-1.6-0.7-1.6-1.6 0.7-1.6 1.6-1.6z m0-6.8c0.9 0 1.6 0.8 1.6 1.8s-0.7 1.6-1.6 1.6-1.6-0.7-1.6-1.6 0.7-1.8 1.6-1.8z' })
        )
    );
};

exports.default = MdBlurOn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/blur-on.js
// module id = 1234
// module chunks = 168707334958949